import React, { useState, useEffect, useContext } from "react";
import './Admindashboard.css'; // Aquí puedes agregar los estilos
import logo from './assets/Logo.png';
import { useMyState } from "./MyContext";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Bar } from 'react-chartjs-2';  // Importamos el gráfico de barras de react-chartjs-2
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { faL } from "@fortawesome/free-solid-svg-icons";
// Registramos los elementos de Chart.js que vamos a usar
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const ContadorVerificador = () =>{
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const history = useHistory();

  if(!isAuthenticated){
    return history.push('/login');
  }
  if(!userRole){
    return history.push('/login');
  }
  if(userRole === 'admin'){
    return history.push('/admin');
  }
  if(userRole === 'usuario'){
    return history.push('/dashboard');
  }
  return Contador();
  
}
export const Contador = () =>{
const {myState2, setMyState2, setMisEmpresas ,setMTabla2} = useMyState();
const history = useHistory();

const handleLogout = () => {
  // Eliminamos el token y el rol de localStorage al hacer logout
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  history.push('/login');
};

  return (
    <div className="dashboard">
      <div className="menu columna">
        <img src={logo}/>
        <div className="menu-list columna">
          <a className="selected" href="#" onClick={() => {
            setMyState2('Usuarios');
            setMisEmpresas('EmpresasUsuarios');
            setMTabla2('TablaUsuarios');
            }}><i class="fa-solid fa-circle-user"></i><span> Usuarios</span></a><br></br>
            <a className="selected" href="" onClick={() =>{handleLogout()}}><i class="fa-solid fa-power-off"></i><span> Cerrar sesión</span></a>
        </div>
      </div>
      <div className="panel">
        <div>
          

          {myState2 === 'Usuarios' && <MostrarUsuarios />}
          {myState2 === 'MostrarTipoUsuario' && <MostrarTipoUsuario/>}
          {myState2 === 'UsuarioInfo' && <UsuarioInfo/>}
        </div>
      </div>
    </div>
  )
}
const MostrarUsuarios = () =>{
  const {myTabla2, setMTabla2, myUser} = useMyState();

  const mostrarComponente = (componente) =>{
    setMTabla2(componente)
  }
  return(
    <div>
      <div className="user-title">
        <h1>¡Bienvenido {myUser}! <span className="ligth-tittle">al panel de contadores, administra a tus cuentas</span></h1>
        <a href="#" onClick={() => mostrarComponente('CrearUsuario')}>Agregar usuario +</a>
      </div>
      {myTabla2 === 'TablaUsuarios' && <TablaUsuarios />}
      {myTabla2 === 'CrearUsuario' && <CrearUsuario />}
    </div>
  )

}
const TablaUsuarios = () =>{
  const [users, setUsers] = useState([]);
  const [contadores, setContadores] = useState([]);
  const [ncontador, setNcontador] = useState();
  const [userid, setUserid] = useState(3);
  const {setMyState2, setMyIdUser, setMyName, nContador, setEstado, setTipo} = useMyState();
  const [loading, setLoading] = useState(true); 
  const [loading2, setLoading2] = useState(true);
  const numContador = 1; // Aquí debería ir el valor de `nContador`
  const [error, setError] = useState(null);
  // Estado para el filtro de nombre
  const [filter, setFilter] = useState('');

  //Obtener usuarios
  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    fetch(`https://contapro.com.mx/php/getusers.php?id=${nContador}`)
      .then(response => response.json())
      .then(data => {
        setUsers(data)
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching users:", error);
        setError(error); // Si ocurre un error, lo guardamos
        setLoading(false); // Terminamos la carga incluso con error
      });
  }, []);
  //Obtener contadores
  useEffect(() => {
        // Hacer la solicitud HTTP al archivo PHP
        fetch('https://contapro.com.mx/php/getcontadores.php')
          .then(response => response.json())
          .then(data => {
            setContadores(data)
            setLoading2(false);  
          })
          .catch(error => {
            console.error("Error fetching contadores:", error);
            setError(error); // Si ocurre un error, lo guardamos
            setLoading2(false); // Terminamos la carga incluso con error
          });
      }, []);

      //cambiar de contador
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        const data = { userid, ncontador };

        try {
            const response = await fetch('https://contapro.com.mx/php/update-contador.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(data),
            });

            const result = await response.text();
            alert(result);  // Muestra el resultado del backend
        } catch (error) {
            alert('Error al actualizar: ' + error);
        }
      };

  const handleUpdateClick = (id, name, status, tipo) => {
    setMyState2('MostrarTipoUsuario')
    setMyIdUser(id);
    setMyName(name)
    setEstado(status);
    setTipo(tipo);
  };
  if (loading || loading2) {
    return <div>Loading...</div>; // Mostrar un mensaje de carga o un spinner mientras cargamos
  }

    

    // Función para manejar el cambio en el campo de texto del filtro
    const handleFilterChange = (e) => {
      setFilter(e.target.value);
    };
  
    // Filtrar los usuarios según el nombre
    const filteredUsers = users.filter(user =>
      user.name.toLowerCase().includes(filter.toLowerCase())
    );

  return (
    <div>
      {/* Campo de filtro */}
      <input
      className="filtro-cards"
        type="text"
        placeholder="Filtrar por nombre"
        value={filter}
        onChange={handleFilterChange}
      />
    <div className="grid-4">
      {filteredUsers.map((user, index) => (
        <div className="card" key={index}>
          <div className="icono-card">
            <i class="fa-regular fa-circle-user"></i>
            <br></br><br></br>
          </div>
          <h2>{user.name}</h2>
          <h4>{user.mail}</h4>
          <div className="buttons-card">
            <form onSubmit={handleSubmit} className="grid-2">
                  <select value={ncontador} onChange={(e) => {
                    setNcontador(e.target.value)
                    setUserid(user.id)
                  }} required>
                    <option value='' >{contadores[user.id_conta - 2].name}</option>
                    {contadores.map((cont, index) =>(
                        <option key={index} value={cont.id}>{cont.name}</option>
                    ))}
                    
                  </select> 
                  <button>Cambiar de contador</button>
            </form>
            <button onClick={() => handleUpdateClick(user.id, user.name, user.status, user.tipo)}>Ver detalles</button>
          </div>
          <p></p>
        </div>
      ))}
    </div>
    </div>
  );
}
const CrearUsuario = () => {
  const {setMTabla2, nContador, myIdUser} = useMyState();
//variables de usuaario empresas
  const [name, setName] = useState("");
  const [correo, setCorreo] = useState("");
  const [contraseña, setContraseña] = useState("");
  const rol = "usuario";
  const [tipo, setTipo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const estatus = 'activo';

  const handleSubmit = async (e) => {
    e.preventDefault();

      // Enviar los datos al backend en PHP
      const response = await fetch(`https://contapro.com.mx/php/create-users.php?id=${nContador}`, {
        method: 'POST',
        body: new URLSearchParams({
          name,
          correo,
          contraseña,
          //tipo,
          rol,
          estatus,
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      const result = await response.text();
      setMensaje(result); // Muestra la respuesta del servidor
      setMTabla2('TablaUsuarios');
      
  };

  return (
    <div className="contenedor">
    <a onClick={() =>setMTabla2('TablaUsuarios')}>Regresar</a>
    <div className="formulario">
      <h2>Crear Usuario</h2>
      <form onSubmit={handleSubmit}>
        <div className="campo">
          <label>Nombre:</label>
          <input
            name="nombre"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Correo:</label>
          <input
            name="correo"
            type="mail"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Contraseña:</label>
          <input
          name="password"
            type="password"
            value={contraseña}
            onChange={(e) => setContraseña(e.target.value)}
            required
          />
        </div>
        {/*<div className="campo">
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            required
          >
            <option value="">--Seleccionar--</option>
            <option value="simple">Simple</option>
            <option value="empresa">Empresa</option>
          </select>
        </div>*/}
        <button type="submit">Registrar</button>
      </form>
      {mensaje && <p>{mensaje}</p>}
    </div>
    </div>
  );
};
const MostrarTipoUsuario = () =>{
  const {tipo} = useMyState();
  return(
    <div>
      {/*tipo === 'empresa' && <MostrarEmpresasUsuarios />}
      {tipo === 'simple' && <UsuarioInfo />*/}
      {<MostrarEmpresasUsuarios />}
    </div>
  )

}
const MostrarEmpresasUsuarios = () =>{
  const {misEmpresas, setMisEmpresas, myName} = useMyState();;

  const mostrarComponente = (componente) =>{
    setMisEmpresas(componente)
  }

  return (
    <div>
      <div className="user-title">
        <h1>¡Bienvenido {myName} <span className="ligth-tittle">a tu portal para conocer el status contable de tu(s) empresa(s)!</span></h1>
        <a href="#" onClick={() => mostrarComponente('CrearEmpresa')}>Agregar empresa +</a>
      </div>
      {misEmpresas === 'EmpresasUsuarios' && <EmpresasUsuarios />}
      {misEmpresas === 'CrearEmpresa' && <CrearEmpresa />}
    </div>
  );
}
const CrearEmpresa = () => {
  const {setMisEmpresas, myIdUser} = useMyState();
  const [nombre, setNombre] = useState("");
  const [rfc, setRfc] = useState("");
  const [tel, setTel] = useState("");
  const [mail, setMail] = useState("");
  const [dfiscal, setDfiscal] = useState("");
  const [regimen, setRegimen] = useState("");
  const [mensaje, setMensaje] = useState("");
  const estatus = 'activo';

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Enviar los datos al backend en PHP
    const response = await fetch(`https://contapro.com.mx/php/crear-empresas.php?id=${myIdUser}`, {
      method: 'POST',
      body: new URLSearchParams({
        nombre,
        rfc,
        tel,
        mail,
        dfiscal,
        regimen,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    const result = await response.text();
    setMensaje(result); // Muestra la respuesta del servidor
    setMisEmpresas('EmpresasUsuarios');
  };

  return (
    <div className="contenedor">
    <a onClick={() =>setMisEmpresas('EmpresasUsuarios')}>Regresar</a>
    <div className="formulario">
      <h2>Crear Empresa</h2>
      <form onSubmit={handleSubmit}>
        <div className="campo">
          <label>Nombre:</label>
          <input
            name="nombre"
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>RFC:</label>
          <input
            name="rfc"
            type="text"
            value={rfc}
            onChange={(e) => setRfc(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Teléfono:</label>
          <input
            name="tel"
            type="text"
            value={tel}
            onChange={(e) => setTel(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Correo:</label>
          <input
            name="mail"
            type="text"
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Dirección Fiscal:</label>
          <input
            name="dfiscal"
            type="text"
            value={dfiscal}
            onChange={(e) => setDfiscal(e.target.value)}
            required
          />
        </div>
        <div className="campo">
          <label>Dirección Fiscal:</label>
          <select id="opciones" value={regimen} onChange={(e) => setRegimen(e.target.value)} required>
            <option value="">--Seleccione--</option>
            <option value="605-Sueldos y Salarios e Ingresos Asimilados a Salarios">605-Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
            <option value="606-Arrendamiento">606-Arrendamiento</option>
            <option value="607-Régimen de Enajenación o Adquisición de Bienes">607-Régimen de Enajenación o Adquisición de Bienes</option>
            <option value="608-Demás ingresos">608-Demás ingresos</option>
            <option value="610-Residentes en el Extranjero sin Establecimiento Permanente en México">610-Residentes en el Extranjero sin Establecimiento Permanente en México</option>
            <option value="611-Ingresos por Dividendos (socios y accionistas)">611-Ingresos por Dividendos (socios y accionistas)</option>
            <option value="612-Personas Físicas con Actividades Empresariales y Profesionales">612-Personas Físicas con Actividades Empresariales y Profesionales</option>
            <option value="614-Ingresos por intereses">614-Ingresos por intereses</option>
            <option value="615-Régimen de los ingresos por obtención de premios">615-Régimen de los ingresos por obtención de premios</option>
            <option value="616-Sin obligaciones fiscales">616-Sin obligaciones fiscales</option>
            <option value="621-Incorporación Fiscal">621-Incorporación Fiscal</option>
            <option value="625-Régimen de las Actividades Empresariales cn ingresos a través de Plataformas Tecnológicas">625-Régimen de las Actividades Empresariales cn ingresos a través de Plataformas Tecnológicas</option>
            <option value="626-Régimen Simplificado de Confianza">626-Régimen Simplificado de Confianza</option>
          </select>
        </div>
        <button type="submit">Crear empresa</button>
      </form>
      {mensaje && <p>{mensaje}</p>}
    </div>
    </div>
  );
};
const EmpresasUsuarios = () =>{
  const [empresas, setEmpresas] = useState([]);
  const {setMyState2, setMyIdEmpresa, setMyName, myIdUser, setEstado, setTipo} = useMyState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    fetch(`https://contapro.com.mx/php/getempresas.php?id=${myIdUser}`)
      .then(response => response.json())
      .then(data => {
        setEmpresas(data)
        setLoading(false)
      })
      .catch(error => console.error("Error fetching users:", error));
  }, []);

  const handleUpdateClick = (id, name) => {
    setMyState2('UsuarioInfo');
    setMyIdEmpresa(id);
    setMyName(name);
  };

  const MensajeEmpresas =  () => {
    return(
     <div>
      <div className="empresas-div">
        {empresas.map((empresa, index) => (
            <div className="empresa-card" key={index} onClick={() => handleUpdateClick(empresa.id, empresa.name )}>
              <i class="fa-regular fa-building"></i>
              <div>
                <h3>{empresa.name}</h3>
                <p>{empresa.rfc}</p>
                <p>{empresa.regimen}</p>
              </div>
            </div>
        ))}
      </div>
     </div>
    )
  }

  const NoEmpresas = () =>{
    return(
      <h1>No hay empresas</h1>
    )
  }
  if (loading) {
    return <div>Loading...</div>; // Mostrar un mensaje de carga o un spinner mientras cargamos
  }
  return (
    <div>
      {
        (empresas.length === 0 ? NoEmpresas() : MensajeEmpresas()) 
      }
    </div>
  );
}
const UsuarioInfo = () =>{
  const {myName, myIdEmpresa, change, setChange} = useMyState();
  const [myOpcion, setMyOpcion] = useState('informacion');
  const [historial, setHistorial] = useState();

  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    fetch(`https://contapro.com.mx/php/gethistorial.php?id=${myIdEmpresa}`)
      .then(response => response.json())
      .then(data => data && setHistorial(data))
      .catch(error => console.error("Error fetching users:", error))
      .finally(() => setChange(false))
  }, [change]);

  const comprobarHistorial = () =>{
    if(historial === 'vacio'){
      alert('no hay historial aún')
    }else{
      setMyOpcion('historial')
    }
  }

  return(
  <div>
    <h1 className="usuario-">Empresa: {myName}</h1>
    <div className="pc">
      <div className="menuUsuario">
      <a href="#" onClick={() => setMyOpcion('informacion')}>Información</a>
      <a href="#" onClick={() => setMyOpcion('contabilidad')}>Contabilidad</a>
      <a href="#" onClick={() => comprobarHistorial()}>Historial</a>
      <a href="#" onClick={() => setMyOpcion('pagos')}>Pagos</a>
      </div>
    </div>
    <div className="mv">
      <div className="menuUsuario-mv">
        <a href="#" onClick={() => setMyOpcion('informacion')}><i class="fa-solid fa-circle-user"></i></a>
        <a href="#" onClick={() => setMyOpcion('contabilidad')}><i class="fa-solid fa-receipt"></i></a>
        <a href="#" onClick={() => comprobarHistorial()}><i class="fa-solid fa-chart-line"></i></a>
        <a href="#" onClick={() => setMyOpcion('pagos')}><i class="fa-solid fa-file-invoice-dollar"></i></a>
      </div>
    </div>
    {myOpcion === 'informacion' && <Informacion />}
    {myOpcion === 'contabilidad' && <Contabilidad />}
    {myOpcion === 'historial' && <Historial/>}
    {myOpcion === 'pagos' && <Pagos/>}
  </div>
  );
}
//Pantallas para editar info del usuario seleccionado
const Informacion = () =>{
  const {estado, myIdEmpresa} = useMyState();
  const [nombre, setNombre] = useState('');
  const [rfc, setRfc] = useState('');
  const [tel, setTel] = useState('');
  const [email, setEmail] = useState('');
  const [dfiscal, setDfiscal] = useState('');
  const [regimen, seRegimen] = useState('');
  const id = myIdEmpresa;
  const [loading, setLoading] = useState(true); 
    
//obtener datos para mostrar antes de editar

  const [usuario, setUsuario] = useState([]);
  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    fetch(`https://contapro.com.mx/php/getinfoempresa.php?id=${id}`)
      .then(response => response.json())
      .then(data => {
        setUsuario(data)
        setLoading(false)
      })
      .catch(error => console.error("Error fetching users:", error));
  }, []);
  
  //actualizar datos del usuario
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = { id, nombre, rfc, tel, email, dfiscal };

        try {
            const response = await fetch('https://contapro.com.mx/php/updateuser.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(data),
            });

            const result = await response.text();
            alert(result);  // Muestra el resultado del backend
        } catch (error) {
            alert('Error al actualizar: ' + error);
        }
        
    };
    if (loading) {
      return <div>Loading...</div>; // Mostrar un mensaje de carga o un spinner mientras cargamos
    }
    return (
        <div className="informacion">
          <h2 className="mv">Información</h2>
            <form onSubmit={handleSubmit}>
            {usuario.map((item, index) =>(
              <div key={index}>
                <div>
                    <label>Nombre: </label>
                    <input 
                        type="text" 
                        
                        placeholder={item.name}
                        onChange={(e) => setNombre(e.target.value)} 
                    />
                </div>
                <div>
                    <label>RFC: </label>
                    <input 
                        type="text" 
                        value={rfc} 
                        placeholder={item.rfc}
                        onChange={(e) => setRfc(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Teléfono: </label>
                    <input 
                        type="tel" 
                        value={tel} 
                        placeholder={item.tel}
                        onChange={(e) => setTel(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Email: </label>
                    <input 
                        type="email" 
                        value={email} 
                        placeholder={item.mail}
                        onChange={(e) => setEmail(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Direccón fiscal: </label>
                    <input 
                        type="text" 
                        value={dfiscal} 
                        placeholder={item.dfiscal}
                        onChange={(e) => setDfiscal(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Régimen: </label>
                    <input 
                        type="text" 
                        value={item.regimen} 
                        //placeholder={item.dfiscal}
                        //onChange={(e) => setDfiscal(e.target.value)} 
                    />
                </div>
                <br></br>
                <button type="submit"><i class="fa-solid fa-floppy-disk"></i> Actualizar</button>
              </div>
              ))}
              
            </form>
            <div className="info-">
              <div className="recuadro">
                <h3>Estado de aplicción</h3>
                <p>{estado} (último pago 25 de oct 2024)</p>
                <h3>Estado de aplicción</h3>
                <p>10 de oct 2024 10:00 AM</p>
              </div>
            </div>
            <ToastContainer />
        </div>
    );
}
const Contabilidad = () =>{
  const {myIdEmpresa, setChange } = useMyState();
  const [mes, setMes] = useState('');
  const [ingresos, setIngresos] = useState('');
  const [gastos, setGastos] = useState('');
  const [iva, setIva] = useState('');
  const [isr, setIsr] = useState('');
  const [rpagar, setRpagar] = useState('');
  const id = myIdEmpresa;
  const [update, setUpdate] = useState(true);

  //const notify = () => alert("¡Notificación!");
    
//obtener datos para mostrar antes de editar
  const [mes1, setMes1 ]= useState('');
  const [ingresos1, setIngresos1] = useState('');
  const [gastos1, setGastos1] = useState('');
  const [iva1, setIva1] = useState('');
  const [isr1, setIsr1] = useState('');
  const [rpagar1, setRpagar1] = useState('');
  const [usuario, setUsuario] = useState([]);
  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    if(update){
      fetch(`https://contapro.com.mx/php/getinfoempresa.php?id=${id}`)
      .then(response => response.json())
      .then(data => {
        // Asumiendo que 'data' es un array y tomas el primer elemento
        if (data && data.length > 0) {
          setUsuario(data); // Guardas los datos completos si es necesario
  
          // Asignar directamente los valores del primer elemento
          const item = data[0]; // Primer elemento
          setMes1(item.mes);
          setIngresos1(item.ingresos);
          setGastos1(item.gastos);
          setIva1(item.iva);
          setIsr1(item.isr);
          setRpagar1(item.rpagar); 
        }
        
      })
      .catch(error => console.error("Error fetching users:", error));
      setUpdate(false);
    }
  }, [update]);

  //insertar historial en la tala historial
  const crearHistorial = async () => {
    // Enviar los datos al servidor PHP
      try {
        const response1 = await fetch(`https://contapro.com.mx/php/crear-historial.php?id=${id}`, {
          method: 'POST',
          body: new URLSearchParams({
            mes1,
            ingresos1,
            gastos1,
            iva1,
            isr1,
            rpagar1,
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        // Mostrar la respuesta del servidor
        const result = await response1.text();
        alert(result); // Muestra la respuesta del servidor
        setChange(true);
      } catch (error) {
        console.error("Hubo un error al insertar los datos:", error);
      }
  };
  
  const crearHistorialcheck = () =>{
    if(mes1 === null || ingresos1 === null || gastos1 === null || iva1 === null || isr1 === null || rpagar1 === null){
      alert('No hay historial o faltan datos')
    }else{
      crearHistorial();
    }
  }

  //actualizar datos del usuario
    const handleSubmit = async (e) => {
        e.preventDefault();
        setUpdate(true);
        const data = { id, mes, ingresos, gastos, iva, isr, rpagar };

        try {
            const response2 = await fetch('https://contapro.com.mx/php/updateempresa-conta.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(data),
            });

            const result = await response2.text();
            //alert(result);  // Muestra el resultado del backend
            alert(result);
           
        } catch (error) {
            alert('Error al actualizar: ' + error);
        }
        
    };

    return (
        <div className="informacion">
          <h2 className="mv">Contabilidad</h2>
            <form onSubmit={handleSubmit}>
            {usuario.map((item, index) =>(
              <div key={index}>
                <div>
                    <label>Mes: </label>
                    <input 
                        type="text" 
                        value={mes}
                        placeholder={item.mes}
                        onChange={(e) => setMes(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Ingresos: </label>
                    <input 
                        type="text" 
                        value={ingresos} 
                        placeholder={item.ingresos}
                        onChange={(e) => setIngresos(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Gastos: </label>
                    <input 
                        type="text" 
                        value={gastos} 
                        placeholder={item.gastos}
                        onChange={(e) => setGastos(e.target.value)} 
                    />
                </div>
                <div>
                    <label>IVA: </label>
                    <input 
                        type="text" 
                        value={iva} 
                        placeholder={item.iva}
                        onChange={(e) => setIva(e.target.value)} 
                    />
                </div>
                <div>
                    <label>ISR: </label>
                    <input 
                        type="text" 
                        value={isr} 
                        placeholder={item.isr}
                        onChange={(e) => setIsr(e.target.value)} 
                    />
                </div>
                <div>
                    <label>Retenciones por pagar: </label>
                    <input 
                        type="text" 
                        value={rpagar} 
                        placeholder={item.rpagar}
                        onChange={(e) => setRpagar(e.target.value)} 
                    />
                </div>
                <br></br>
                <button type="submit"><i class="fa-solid fa-floppy-disk"></i> Actualizar</button>
                <a onClick={crearHistorialcheck} className="historial-btn"><i class="fa-solid fa-floppy-disk"></i> Crear Historial</a>
              </div>
              ))}
            </form>
            <div className="info-">
              <div className="recuadro">
                <h3>Constancia Fiscal</h3>
                <p>{ViewPDF()}{UploadPDF()}</p>
                <h3>Impuestos por pagar</h3>
                <p>{ViewPDF2()}{UploadPDF2()}</p>
              </div>
            </div>
            <ToastContainer />
        </div>
    );
}
const UploadPDF = () => {
  const {myIdEmpresa} = useMyState();
  const [file, setFile] = useState(null);  // Para el archivo PDF

  // Maneja el cambio del archivo
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);  // Guardamos el archivo seleccionado
  };

  // Enviar el archivo al servidor
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Verificar que el archivo sea válido
    if (!file) {
      alert('Por favor, selecciona un archivo.')
      return;
    }

    // Crear un FormData para enviar los datos al servidor
    const formData = new FormData();
    formData.append('pdf', file);  // Agregar el archivo

    try {
      // Hacer la solicitud POST al backend PHP con el ID del archivo en la URL
      const response = await fetch(`https://contapro.com.mx/php/pdf.php?id=${myIdEmpresa}`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();  // Parsear la respuesta como JSON
      if (response.ok) {
        alert('Archivo procesado correctamente.');
      } else {
        alert('Hubo un error al procesar el archivo.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al subir el archivo.');
    }
  };

  return (
    <div>
      <form className="form_pdf" onSubmit={handleSubmit}>
          <input
            type="file"
            id="pdf"
            name="pdf"
            accept="application/pdf"
            onChange={handleFileChange}
          />

        <button type="submit">Subir/Actualizar PDF</button>
      </form>
      <ToastContainer />
    </div>
  );
}
const ViewPDF = () => {
  const {myIdEmpresa} = useMyState();
  const [url, setUrl] = useState();

  const downloadUrl = `https://contapro.com.mx/php/get_pdf.php?id=${myIdEmpresa}`;

 /* const handleDownload = () => {
    // Generar la URL de descarga
    const downloadUrl = `https://contapro.com.mx/php/get_pdf.php?id=${myIdUser}`;
    setUrl(downloadUrl);
    alert(downloadUrl);
    // Crear un enlace y forzar la descarga
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `archivo_${myIdUser}.pdf`; // Puedes usar cualquier nombre para el archivo
    link.click();
  };*/

  return (
    <div>
      <a href={downloadUrl} target="_blank">Constancia Fiscal</a>
    </div>
  );
}
const UploadPDF2 = () => {
  const {myIdEmpresa} = useMyState();
  const [file, setFile] = useState(null);  // Para el archivo PDF

  // Maneja el cambio del archivo
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);  // Guardamos el archivo seleccionado
  };

  // Enviar el archivo al servidor
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Verificar que el archivo sea válido
    if (!file) {
      alert('Por favor, selecciona un archivo.');
      return;
    }

    // Crear un FormData para enviar los datos al servidor
    const formData = new FormData();
    formData.append('pdf', file);  // Agregar el archivo

    try {
      // Hacer la solicitud POST al backend PHP con el ID del archivo en la URL
      const response = await fetch(`https://contapro.com.mx/php/pdf_impuestos.php?id=${myIdEmpresa}`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();  // Parsear la respuesta como JSON
      if (response.ok) {
        alert('Archivo procesado correctamente.');
      } else {
        alert('Hubo un error al procesar el archivo.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al subir el archivo.');
    }
  };

  return (
    <div>
      <form className="form_pdf" onSubmit={handleSubmit}>
          <input
            type="file"
            id="pdf"
            name="pdf"
            accept="application/pdf"
            onChange={handleFileChange}
          />

        <button type="submit">Subir/Actualizar PDF</button>
      </form>

      <ToastContainer />
    </div>
  );
}
const ViewPDF2 = () => {
  const {myIdEmpresa} = useMyState();
  //const downloadUrl = '';


  const downloadUrl = `https://contapro.com.mx/php/get_pdf_impuestos.php?id=${myIdEmpresa}`;


  /*const handleDownload = () => {
    // Generar la URL de descarga
    const downloadUrl = `https://contapro.com.mx/php/get_pdf_impuestos.php?id=${myIdUser}`;
    // Crear un enlace y forzar la descarga
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `archivo_${myIdUser}.pdf`; // Puedes usar cualquier nombre para el archivo
    link.click();
  };*/

  return (
    <div>
      <a href={downloadUrl} target="_blank">Impuestos por pagar</a> 
    </div>
  );
}
const Historial = () =>{
  // Variables predefinidas con los datos
  const meses1 = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo'];  // Meses
  const [meses, setMeses] = useState([]);
  const ingresos1 = [30, 45, 60, 70, 50];  // Ventas correspondientes a cada mes
  const [ingresos, setIngresos] = useState([]);
  const gastos2 = [30, 45, 60, 70, 50];  // Ventas correspondientes a cada mes
  const [gastos, setGastos] = useState([]);




  // Usamos las variables para crear los datos para la gráfica
  const data = {
    labels: meses,  // Usamos la variable meses como etiquetas
    datasets: [
      {
        label: 'Ingresos',  // Título de la serie
        data: ingresos,  // Usamos la variable ventas como los datos
        backgroundColor: 'rgba(75, 192, 83, 0.2)',  // Color de las barras
        borderColor: 'rgba(75, 192, 192, 1)',  // Color del borde de las barras
        borderWidth: 1,
      },
      {
        label: 'Gastos',  // Título de la serie
        data: gastos,  // Usamos la variable ventas como los datos
        backgroundColor: 'rgba(75, 186, 192, 0.2)',  // Color de las barras
        borderColor: 'rgba(75, 192, 192, 1)',  // Color del borde de las barras
        borderWidth: 1,
      },
    ],
  };

  // Opciones para personalizar la gráfica
  const options = {
    responsive: true,  // Hacer que la gráfica sea responsiva
    plugins: {
      title: {
        display: true,
        text: '(OCT-2023 -- DEC 2024)',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,  // El eje Y comienza en cero
      },
    },
    animation: {
      duration: 1500, // Duración de la animación en milisegundos
      easing: 'easeOutBounce', // Tipo de animación (puedes probar otros como 'easeInOutQuad', 'linear', etc.)
      onProgress: function(animation) {
        //console.log('Animación en progreso: ' + animation.currentStep);
      },
      onComplete: function() {
        //console.log('Animación completada');
      }
    }
  };


  //obtener los historiales
  const [historial, setHistorial] = useState([]);
  const {myIdEmpresa} = useMyState();
  const [myHistorial, setMyHistorial] = useState(0);
  const [isLoading, setIsLoading] = useState(true)
  const [loading, setLoading] = useState(true); 
  useEffect(() => {
    // Hacer la solicitud HTTP al archivo PHP
    fetch(`https://contapro.com.mx/php/gethistorial.php?id=${myIdEmpresa}`)
      .then(response => response.json())
      .then(data => {
        data && setHistorial(data)
        setLoading(false)
      })
      .catch(error => console.error("Error fetching users:", error))
      .finally(() => datosGrafica())
  }, []);

const datosGrafica = () =>{
  setIsLoading(false)
}

//cargamos los datos obtenidos en los arreglos
useEffect( () =>{
  const mes =  !isLoading && historial.map(item => item.mes);
  setMeses(mes)
  const ing =  !isLoading && historial.map(item => item.ingresos);
  setIngresos(ing)
  const gas =  !isLoading && historial.map(item => item.gastos);
  setGastos(gas)
}, [isLoading]);

  const mostrarInfomes = () =>{
    return(
      <div className="recuadro">
                <div>
                  <h3>Ingresos</h3>
                  {!isLoading && <p>${historial[myHistorial].ingresos}</p>}
                </div>
                <div>
                  <h3>Gastos</h3>
                  {!isLoading && <p>${historial[myHistorial].gastos}</p>}
                </div>
                <div>
                  <h3>IVA</h3>
                  {!isLoading && <p>${historial[myHistorial].iva}</p>}
                </div>
                <div>
                  <h3>ISR</h3>
                  {!isLoading && <p>${historial[myHistorial].isr}</p>}
                </div>
                <div>
                  <h3>Retenciones</h3>
                  {!isLoading && <p>${historial[myHistorial].rpagar}</p>}
                </div>
        </div>
    )
  }

  const mostrarMeses = () =>{
    return(
      <>
        {historial !== 'vacio' && historial.map((his, index) =>(
            <div className="mes-item" key={index} onClick={() => mostrarInfo(index)}>
            <i class="fa-regular fa-file-lines"></i>
              <div>
                <p>${his.ingresos}</p>
                <h3>{his.mes}</h3>
              </div>
            </div>
          ))}
      </>
    )
  }

  const mostrarMensaje = () =>{
    alert('No hay historial')
  }

  const mostrarInfo = (id) =>{
    setMyHistorial(id);
    console.log(id);
    //mostrarInfomes(id);
  }
  if (loading) {
    return <div>Loading...</div>; // Mostrar un mensaje de carga o un spinner mientras cargamos
  }
  return (
    <div className="historial">
      <h2 className="mv">Historial</h2>
      <div className="grafica">
        <h2>Tnedencia anual</h2>
        <div className="grafica-tabla">
          <Bar data={data} options={options} />  {/* Renderizamos la gráfica */}
        </div>
      </div>
      <div className="panel-info">
        <div className="meses">
          <h2>Meses</h2>
          {(historial === 'vacio' ? mostrarMensaje() : mostrarMeses())}
        </div>
        {(historial === 'vacio' ? mostrarMensaje() : mostrarInfomes())}
      </div>
    </div>
  )
}
const Pagos = () =>{
  return <h2>Pendiente</h2>
}
//

export default ContadorVerificador;